import React from 'react';

interface ToggleOption {
  id: string;
  label: string;
  width: string;
}

interface ToggleButtonProps {
  options: ToggleOption[];
  selectedId: string;
  onChange: (id: string) => void;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ options, selectedId, onChange }) => {
  return (
    <div className='relative flex w-[130px] justify-between rounded-full border-gray-300 bg-[#EFEFEF] p-px text-sm font-medium'>
      {options.map((option) => (
        <button
          key={option.id}
          className={`${'w-[' + option.width + ']'} z-10 rounded-full px-3 text-[10px] transition-colors duration-300 ${
            selectedId === option.id
              ? 'rounded-full bg-white text-black drop-shadow-sm'
              : 'text-[#888888]'
          }`}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleButton;
